module.exports = __webpack_public_path__ + "img/gzh.a6c9abf7.png";